import { Routes } from "@angular/router";

export const content: Routes = [
  
  {
    path: "objects",
    loadChildren: () => import("../../components/objects/objects.module").then((m) => m.ObjectsModule),
  },
  {
    path: "workers",
    loadChildren: () => import("../../components/workers/workers.module").then((m) => m.WorkersModule),
  },
  {
    path: "newusers",
    loadChildren: () => import("../../components/newusers/newusers.module").then((m) => m.NewusersModule),
  },

  {
    path: "rooms",
    loadChildren: () => import("../../components/rooms/rooms.module").then((m) => m.RoomsModule),
  },
  
  {
    path: "admins",
    loadChildren: () => import("../../components/admins/admins.module").then((m) => m.AdminsModule),
  },
  
  {
    path: "bookings",
    loadChildren: () => import("../../components/bookings/bookings.module").then((m) => m.BookingsModule),
  },
  
  {
    path: "clients",
    loadChildren: () => import("../../components/clients/clients.module").then((m) => m.ClientsModule),
  },
  
];
